import VcTimes from "./VcTimes"

export default VcTimes;
